import { FC } from "react";
import Lightbox from "react-image-lightbox";

type Props = {
  open: boolean;
  setOpen: any;
  gallery: any;
  index: number;
  setIndex: (i: number) => void;
};

const GalleryLightBox: FC<Props> = ({
  open,
  index,
  gallery,
  setOpen,
  setIndex,
}) => {
  if (!open) {
    return null;
  }
  if (!gallery) {
    return null;
  }
  if (gallery === "null") {
    return null;
  }

  return (
    <>
      <Lightbox
        imageTitle={
          gallery[index].data
            ? `${
                gallery[index].data.caption
                  ? `${gallery[index].data.caption} |`
                  : ""
              }  ${
                gallery[index].data.copyright
                  ? gallery[index].data.copyright
                  : ""
              } `
            : ""
        }
        mainSrc={gallery[index].data.url}
        nextSrc={gallery[(index + 1) % gallery.length].data?.url}
        prevSrc={
          gallery[(index + gallery.length - 1) % gallery.length].data?.url
        }
        onCloseRequest={() => setOpen(false)}
        onMovePrevRequest={() => index !== 0 && setIndex(index - 1)}
        onMoveNextRequest={() =>
          index < gallery.length - 1 && setIndex(index + 1)
        }
      />
    </>
  );
};

export default GalleryLightBox;
